var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var GeneralScoreboard = /** @class */ (function (_super) {
    __extends(GeneralScoreboard, _super);
    function GeneralScoreboard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GeneralScoreboard.prototype.render = function () {
        return (React.createElement("div", { className: "rj-general-scoreboard" + (this.props.modifier ? " rj-general-scoreboard--" + this.props.modifier : "") },
            React.createElement("div", { className: "rj-general-scoreboard__players" },
                this.props.scoreFirstPlayer.map(function (item, index) { return (React.createElement("div", { key: index, className: "rj-general-scoreboard__info" }, item)); }),
                React.createElement("div", { className: "rj-general-scoreboard__total-info" }, this.props.totalFirstPlayer)),
            React.createElement("div", { className: "rj-general-scoreboard__players" },
                this.props.scoreSecondPlayer.map(function (item, index) { return (React.createElement("div", { key: index, className: "rj-general-scoreboard__info" }, item)); }),
                React.createElement("div", { className: "rj-general-scoreboard__total-info" }, this.props.totalSecondPlayer))));
    };
    return GeneralScoreboard;
}(React.PureComponent));
export { GeneralScoreboard };
//# sourceMappingURL=GeneralScoreboard.js.map